import { Typography } from '@mui/material';
import { PasswordsMatchTextContainer } from 'components/password-strength/styles';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import { PROFILE__PINCODE_MATCH, PROFILE__PINCODE_NO_MATCH } from 'translations/constants';
import { ReactComponent as CheckIcon } from '../../assets/icons/CheckIcon.svg';

interface PincodeMatchTextProps {
  match: boolean;
}

/** Same visual language as PasswordsMatchText, with pincode-specific copy. */
const PincodeMatchText = ({ match }: PincodeMatchTextProps) => {
  const [t] = useTranslation();

  return (
    <PasswordsMatchTextContainer>
      {match && <CheckIcon />}
      <Typography fontSize={12} color={match ? theme.palette.primary.main : theme.palette.error.main}>
        {match ? t(PROFILE__PINCODE_MATCH) : t(PROFILE__PINCODE_NO_MATCH)}
      </Typography>
    </PasswordsMatchTextContainer>
  );
};

export default PincodeMatchText;
